import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "calendar-view",
  ref: "calendarEl"
}
const _hoisted_2 = {
  key: 0,
  class: "calendar-loading",
  role: "status",
  "aria-live": "polite"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calendar-view-wrapper", { 'calendar-empty-message-ready': $setup.showEmptyMessage }])
  }, [
    _createElementVNode("div", _hoisted_1, null, 512 /* NEED_PATCH */),
    ($setup.isCalendarLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("span", {
            class: "calendar-loading-spinner",
            "aria-hidden": "true"
          }, null, -1 /* CACHED */),
          _createElementVNode("span", null, "読み込み中…", -1 /* CACHED */)
        ])))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}